<template>
  <div id="app">
    <keep-alive v-if="isKeep">
      
      <a-config-provider :locale="zh_CN">
        <router-view/>
      </a-config-provider>
    </keep-alive>
  </div>
</template>


<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { ConfigProvider } from "ant-design-vue";
import { print2, renderAndPrint } from "@/components/PrintTemplate/index.js"
export default {
  data() {
    return {
      isKeep: true,
      zh_CN
    }
  },
  components: {
    [ConfigProvider.name]: ConfigProvider,
  },
  methods: {
    cleanKeepCache: function () {
      this.isKeep = false;
      this.$nextTick((_) => {
        this.isKeep = true;
      })
    }
  },
  provide() {
    return {
      cleanKeepCache: this.cleanKeepCache
    }
  },
  mounted(){
    // renderAndPrint('https://static-s.theckb.com/testimg/FBA15FTGCY14-1744611851963.pdf')
  }
}
</script>

<style lang="stylus">
#app
  font-family Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #2c3e50
  margin 0
  padding 0
  height 100vh
body, html {
  margin 0
  padding 0
  background: #f6f6f6;
}
body ul, body li {
  margin: 0;
  padding: 0;
  list-style: none;
}
.is-disabled .el-input__inner {
  color: #3a3a3a!important
}
  .vue-directive-image-previewer {
    z-index 9999
  }
  .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    padding: 10px 16px !important;
    overflow-wrap: break-word;
}
.global-messageZindex{
  z-index 9998
}

.el-dialog__header{
  height: 60px;
  width: 100%;
  font-size: 20px;
  background-color: #00284d;
  display: flex;
  align-items: center;
  text-align: left;
  box-sizing: border-box;
  padding : 0 0 0 20px !important

  button{
    i{
      font-weight: 600;
      font-size: 20px;
    }
  }

  .el-dialog__title{
    color: #e8e8e8;
  }

  .el-dialog__headerbtn{
    height: 60px;
    width: 60px;
    top:0;
    right: 0
  }

  .el-dialog__headerbtn .el-dialog__close {
    color:#FFFFFF
  }
}

</style>
<style>
.line--1 {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	overflow: hidden;
	text-overflow: ellipsis;
}
.line--2 {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	text-overflow: ellipsis;
  word-break: break-all;
}
.line--3 {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
	overflow: hidden;
	text-overflow: ellipsis;
}
.el-message {
  z-index: 50000!important;
}
.ant-message {

  z-index: 50000!important;
}
.publicCustomerTagName{
  max-width: 140px;
  min-width: 100px;
  flex-shrink: 0;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 4px;;
  background-color: red;
  color: #fff;
  margin-top: 1px;
}

.el-form--inline .el-form-item{
  margin-bottom: 8px;
}

.productPriceInput .el-input .el-input-group__append{
  padding: 0 8px;
}

.ant-modal-confirm .ant-modal-wrap , .ant-modal-confirm .ant-modal {
  z-index: 4800;
}
.tag-side-content {
  position: absolute;
  top:0;
  left:0;
}
.tag-side-content .tag-item {
  background: rgba(0,0,0,0.8);
  color:#fff;
  padding: 2px 4px;
  border-radius: 2px;
  display: inline-block;
  vertical-align: top;
  margin-right: 4px;
  font-size: 12px;
}
</style>
